import React from 'react';
import { Row, Col } from 'react-bootstrap';
import {
  Wifi,
  Tv,
  ThermometerSnowflake,
  Coffee,
  Car,
  Dumbbell
} from 'lucide-react';

const Amenities = () => {
  const amenities = [
    { icon: Wifi, label: 'Free Wi-Fi' },
    { icon: Tv, label: 'Smart TV' },
    { icon: ThermometerSnowflake, label: 'Air Conditioning' },
    // { icon: Coffee, label: 'Complimentary Breakfast' },
    { icon: Car, label: 'Free Parking' },
    { icon: Dumbbell, label: 'Fitness Center' },
  ];

  return (
    <section className="amenities-section py-5">
         <h4 className="mb-4" style={{ color: '#0d3b66', fontWeight: 600 }}>
          Our Amenities
        </h4>
      <div className="container text-center">
       
        <Row className="gy-4 gx-3 justify-content-center">
          {amenities.map(({ icon: Icon, label }) => (
            <Col key={label} xs={6} sm={6} md={4} lg={2} >
              <div
                className="p-4 bg-white  shadow-sm h-100 d-flex flex-column align-items-center justify-content-center "
                style={{borderRadius:'15px'}}
              >
                <Icon size={40} className="mb-3" style={{color:'#54b435'}} />
                <span className="fw-semibold" style={{color:'#0f172a'}}>{label}</span>
              </div>
            </Col>
          ))}
        </Row>
      </div>
    </section>
  );
};

export default Amenities;
